var map = {
	"./stack_0.png": "5eb4",
	"./stack_1.png": "b6d5",
	"./stack_2.png": "fc1d",
	"./stack_3.png": "1c6e0",
	"./stack_4.png": "1f41",
	"./stack_5.png": "83bd",
	"./stack_6.png": "371e",
	"./stack_7.png": "3d1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10c2";